<template>
    <div class="bannerBox">
        <div class="navBox">
            <div class="navDhShow">
                <div :class="activeIndex=='index'?'isActive':'moren'" @click="handleSelect('index','index')">首页</div>
                <div class="pore" :class="activeIndex=='partyBuild'?'isActive':'moren'">
                    <p class="">党建园地</p>
                    <div class="second">
                        <p @click="handleSelect('partyBuild?type=102101','partyBuild')">党建文件</p>
                        <p @click="handleSelect('partyBuild?type=102102','partyBuild')">党建活动</p>
                    </div>
                </div>
                <div class="pore" :class="activeIndex=='association'?'isActive':'moren'">
                    <p>协会概况</p>
                    <div class="second">
                        <p @click="handleSelect('association/Intro','association')">协会简介</p>
                        <p @click="handleSelect('association/Article','association')">协会章程</p>
                        <p @click="handleSelect('association/Team','association')">组织架构</p>
                        <p @click="handleSelect('association/Member','association')">理事会成员</p>
                    </div>
                </div>
                <div class="pore" :class="activeIndex=='notice'?'isActive':'moren'">
                    <p>通知资讯</p>
                    <div class="second">
                        <p @click="handleSelect('notice?type=106101','notice')">通知公告</p>
                        <p @click="handleSelect('notice?type=106102','notice')">协会工作</p>
                        <p @click="handleSelect('notice?type=106103','notice')">行业动态</p>
                    </div>
                </div>
                <!-- <div class="pore" :class="activeIndex=='meet'?'isActive':'moren'">
                    <p>会议列表</p>
                    <div class="second">
                        <p @click="handleSelect('meet','2')">会议列表</p>
                    </div>
                </div> -->
                <div class="pore" :class="activeIndex=='service'?'isActive':'moren'">
                    <p>服务平台</p>
                    <div class="second">
                        <p @click="handleSelect('service?type=106104','service')">会员风采</p>
                        <p @click="handleSelect('http://member.hbaec.com/Jzxh/Login.aspx','blank')">会员登录</p>
                        <p @click="handleSelect('http://member.hbaec.com/Jzxh/Web/Dw/DwRegister.aspx','blank')">入会申请</p>
                    </div>
                </div>
                <div class="pore" :class="activeIndex=='business'?'isActive':'moren'">
                    <p>业务办理</p>
                    <div class="second">
                        <p @click="handleSelect('https://new.tzxm.gov.cn/','blank')">咨询单位备案</p>
                        <p @click="handleSelect('https://zhywglxt.cnaec.com.cn/#/consultant_login?redirect=%2F','blank')">资信评价系统</p>
                        <p @click="handleSelect('http://yxcg.hbaec.com/user/login','blank')">优秀成果申报</p>
                        <p @click="handleSelect('http://zyjc.hbaec.com/zyjc/classfiy','blank')">执业检查系统</p>
                        <p @click="handleSelect('http://zjk.hbaec.com/','blank')">咨询专家库</p>
                    </div>
                </div>
                <div class="pore" :class="activeIndex=='industrySelf'?'isActive':'moren'">
                    <p>行业自律</p>
                    <div class="second">
                        <p @click="handleSelect('industrySelf','industrySelf')">行业自律</p>
                    </div>
                </div>
                <div class="pore" :class="activeIndex=='policyRegulate'?'isActive':'moren'">
                    <p>政策法规</p>
                    <div class="second">
                        <p @click="handleSelect('policyRegulate','policyRegulate')">政策法规</p>
                    </div>
                </div>
                <div class="pore" :class="activeIndex=='linkUs'?'isActive':'moren'">
                    <p>联系我们</p>
                    <div class="second">
                        <p @click="handleSelect('linkUs','linkUs')">联系我们</p>
                    </div>
                </div>
                <div style="float: right;margin-top: -4px;">
                    <el-input placeholder="请输入关键词搜索" prefix-icon="el-icon-search" v-model="title" @change="searchData">
                        <el-button type="primary" slot="append" icon="el-icon-search" @click="searchData"></el-button>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="logoBox">
            <div class="logoTBox">
                <img class="logoNew" src="@/assets/home/logon.png" alt="">
                <img class="logoBig" src="@/assets/home/logoB.png" alt="">
            </div>
            <img class="logoTitle" src="@/assets/home/title.png" alt="">
        </div>
        <!-- <div class="headerContent">
            <div :class="activeIndex=='index'?'isActive':'moren'" @click="handleSelect('index')">首页</div>
            <div :class="activeIndex=='partyBuild'?'isActive':'moren'" @click="handleSelect('partyBuild')">党建园地</div>
            <div :class="activeIndex=='assocaIntro'?'isActive':'moren'" @click="handleSelect('assocaIntro')">协会简介</div>
            <div :class="activeIndex=='assocaArticle'?'isActive':'moren'" @click="handleSelect('assocaArticle')">协会章程</div>
            <div :class="activeIndex=='industrySelf'?'isActive':'moren'" @click="handleSelect('industrySelf')">行业自律</div>
            <div :class="activeIndex=='policyRegulate'?'isActive':'moren'" @click="handleSelect('policyRegulate')">政策法规</div>
            <div :class="activeIndex=='linkUs'?'isActive':'moren'" @click="handleSelect('linkUs')">联系我们</div>
            <el-input placeholder="请输入关键词搜索" v-model="title" class="inputBox" @change="searchData">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>  -->
    </div>
</template>

<script>
export default {
    name: 'Header',
    data() {
        return {
            activeIndex: '1',
            title:''
        };
    },
    watch: {
        $route: {
            handler(value){
                // 初始化activeIndex
                let path = value.path.split('/')
                if(path){
                    let activeIndex = path[1]
                    this.activeIndex = activeIndex
                }
            },
            immediate: true
        }
    },
    mounted(){
    },
    methods: {
        // 导航切换
        handleSelect(keyPath,type) {
            if(type=='blank'){ //跳转网站外部链接
                window.open(keyPath,'_blank')
            }else{
                if (type == 2) { //跳转会议
                    window.location.href = 'http://www.hbaec.com/web/Meeting.aspx'
                }else{
                    let path = '/'
                    path+=keyPath
                    this.$router.push({
                        path,
                    })
                }
            }
        },
        //查询搜索结果
        searchData(){
            if(!this.title){
                this.$message.info('请填写关键字')
                return
            }
            this.$router.push({
                path:'/new?title='+this.title
            })
        }
    }
}
</script>

<style lang="less">
    .bannerBox{
        position: relative;
        width: 100%;
        height: 360px;
        background: url('../assets/home/bannernew.png') no-repeat;
        background-size: 100% 100%;
    }
    .navBox{
        width: 100%;
        height: 80px;
        background-color: rgba(255,255,255,.6);
    }
    .navDhShow{
        width: 1400px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        font-size: 20px;
    }
    .navDhShow>div{
        line-height: 80px;
    }
    .second{
        position: absolute;
        top: 80px;
        left: 50%;
        z-index: 100;
        width: 150px;
        margin-left: -75px;
        line-height: 50px;
        height:auto;
        background-color: #0D69F0;
        color: #fff;
        text-align: center;
        display: none;
        font-size: 16px;
    }
    .pore:hover .second{
        display: block;
    }
    .second p:hover{
        color: #0D69F0;
        background-color: #fff;
    }
    
    .el-input-group{
        width: 240px;
        height: 40px;
    }
    .el-input__inner{
        height: 40px !important;
    }
    .el-input-group__append button.el-button{
        color: #409EFF;
    }
    .topBox{
        width: 1400px;
        margin: 0 auto;
    }
    .logoBox{
        width: 1400px;
        margin: 0 auto;
        padding-top: 45px;
    }
    .logoTBox{
        display: flex;
        justify-content: flex-start;
        margin-top: 5px;
    }
    .logoNew{
        width: 100px;
        height: 100px;
        margin-top: -10px;
        margin-left: 20px;
    }
    .logoBig{
        width: 450px;
    }
    .logoTitle{
        display: block;
        width: 580px;
        margin: 0 auto;
        margin-top: 40px;
    }
    .moren{
        cursor: pointer;
        padding: 0 15px;
        cursor: pointer;
        font-weight: bold;
    }
    .isActive{
        color: #0D69F0;
        padding: 0 15px;
        cursor: pointer;
        font-weight: bold;
    }
</style>